import { useEffect } from "react";
import { useUser } from "context/UserContext";
import { useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/city.jpg";
import LoadingSpinner from "controls/LoadingSpinner";

function SignOutPage() {
  const { logout, isLoggedIn } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      if (isLoggedIn) {
        await logout();
        navigate("/authentication/sign-in");
      }else{
        navigate("/authentication/sign-in");
      }
    };
    run();
  }, [isLoggedIn, logout, navigate]);

  return (
    <BasicLayout image={bgImage}>
      <Card sx={{ maxWidth: 400, mx: "auto", mt: 8, p: 3, textAlign: "center" }}>
        <MDBox mb={3}>
          <img
            src={require("assets/images/logo/mainlogo.png")}
            alt="logo"
            width="200px"
            style={{ display: "block", margin: "0 auto" }}
          />
        </MDBox>
        <LoadingSpinner title="Signing you out..." size={25} />
        <MDTypography
          variant="body2"
          sx={{ mt: 1 }}
        >
          Please wait while we sign you out.
        </MDTypography>
        <MDTypography
          variant="body2"
        >
          See you soon!
        </MDTypography>
      </Card>
    </BasicLayout>
  );
}

export default SignOutPage;
